import React from "react";

const MapComponentUx = React.memo(({parcel_code, longitude, latitude}) => {
    const mapRef = React.useRef(null);
    React.useEffect(() => {
        let google = window.google;

        let map = mapRef.current;

        const mapOptions = {
            zoom: 16,
            //center: myLatlng,
            scrollwheel: false,
            zoomControl: true,
            styles: [
                {
                    featureType: "administrative",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#444444"}],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [{color: "#f2f2f2"}],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [{saturation: -100}, {lightness: 45}],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [{visibility: "simplified"}],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.icon",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "water",
                    elementType: "all",
                    stylers: [{color: "#4299e1"}, {visibility: "on"}],
                },
            ],
            disableDefaultUI: true,
            gestureHandling: 'none',
        };

        map = new google.maps.Map(map, mapOptions);

        let lat = latitude || "29.548060";
        let lng = longitude || "-104.417663";

        const centerLatLng = new google.maps.LatLng(lat, lng);
        map.setCenter(centerLatLng);

        if (parcel_code) {
            map.data.loadGeoJson(`/lots/${parcel_code}/geojson.json`);

            map.data.setStyle({
                fillColor: "#2196f3",
                strokeWeight: 1,
                strokeColor: "#1766A6",
            });
        }
    });
    return (
        <>
            <div className="relative w-full rounde h-full">
                <div className="rounded h-full" ref={mapRef}/>
            </div>
        </>
    );
});

export default MapComponentUx;